import React, { useState } from "react";
import { useFormik } from 'formik';

import EditTextForm from "../../components/EditTextForm/EditTextForm";
import { COLORS } from "../../constants/colors";
import Paint from "../../components/Paint/Paint";
import globalStyle from "../../styles/globalStyle.module.css";
import { LockFilled } from "@ant-design/icons";
import LoadingButton from "../../components/LoadingButton/LoadingButton";
import './Configuration.css';
import { useAuth } from "../../../contexts/auth";
import { getError, openNotification, tryCatch } from "../../constants/Utilities";
import ModalContainer from "../../components/ModalContainer/ModalContainer";


// Interfal Interface
interface ChangePassword {
    accessCode: string;
    newAccessCode: string;
    confirmAccessCode: string;
}


// Props
interface Props {
    setVisibleConf: React.Dispatch<React.SetStateAction<boolean>>;
}

const Password: React.FC<Props> = ({ setVisibleConf }) => {

    // States
    const [loading, setLoading] = useState<boolean>(false);
    const { changePassword } = useAuth();


    // Methods
    const validations = (values: ChangePassword) => {
        const errors: any = {};
        if (!values.accessCode) {
            errors.accessCode = 'Requerido';
        }   

        if (!values.newAccessCode) {
            errors.newAccessCode = 'Requerido';
        }

        if (!values.confirmAccessCode) {
            errors.confirmAccessCode = 'Requerido';
        } else if (values.newAccessCode != values.confirmAccessCode) {
            errors.confirmAccessCode = 'Debe ser igual a la nueva contraseña';
        }

        return errors;
    };


    // Handles
    const handleChangePassword = (oldPass: string, newPass: string) => {
        tryCatch(() => {
            setLoading(true);
            changePassword(oldPass, newPass)
                .then((response) => {
                    openNotification('success', `Contraseña Modificada`, response);
                    setVisibleConf(false);
                })
                .catch((error) => {
                    openNotification('error', 'Error', getError(error));
                })
                .finally(() => setLoading(false));
        })

    }

    // Form
    const passwordForm = useFormik({
        initialValues: { accessCode: '', newAccessCode: '', confirmAccessCode: '' },
        validate: validations,
        onSubmit: (values: ChangePassword) => handleChangePassword(values.accessCode, values.newAccessCode)
    });

    return (
        <ModalContainer>
            <p className="password_title">Cambiar Contraseña</p>
            <div className="password_marginInput">
                <label>Contraseña actual:</label>
                <div className="password_input">
                    <EditTextForm
                        value={passwordForm.values.accessCode}
                        onChange={passwordForm.handleChange}
                        backgroundcolor={'transparent'}
                        name={"accessCode"}
                        Icon={<LockFilled />}
                        placeholder={"Contraseña actual"}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                        active={!loading}
                        type={'password'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{passwordForm.errors.accessCode && passwordForm.errors.accessCode}</Paint>
                    </p>
                </div>
            </div>

            <div className="password_marginInput">
                <label>Nueva contraseña:</label>
                <div className="password_input">
                    <EditTextForm
                        value={passwordForm.values.newAccessCode}
                        onChange={passwordForm.handleChange}
                        backgroundcolor={'transparent'}
                        name={"newAccessCode"}
                        Icon={<LockFilled />}
                        placeholder={"Contraseña nueva"}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                        active={!loading}
                        type={'password'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{passwordForm.errors.newAccessCode && passwordForm.errors.newAccessCode}</Paint>
                    </p>
                </div>
            </div>


            <div className="password_marginInput">
                <label>Confirmar contraseña:</label>
                <div className="password_input">
                    <EditTextForm
                        value={passwordForm.values.confirmAccessCode}
                        onChange={passwordForm.handleChange}
                        backgroundcolor={COLORS.transparent_color1}
                        name={"confirmAccessCode"}
                        Icon={<LockFilled />}
                        placeholder={"Confirmar contraseña"}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                        active={!loading}
                        type={'password'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{passwordForm.errors.confirmAccessCode && passwordForm.errors.confirmAccessCode}</Paint>
                    </p>
                </div>

            </div>

            <LoadingButton
                type="button"
                method={passwordForm.handleSubmit}
                title={"Enviar"}
                loading={loading.toString()}
                background={COLORS.blue_active}
                color={COLORS.white_color1}
                style={{ padding: '3px', width: '200px', margin: 'auto 15% auto auto', height: '32px' }}
                fontsize={16}
            />
        </ModalContainer>
    );
}

export default Password;